import { FC, useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import { important } from 'common-types';
import { useInfinityScroll } from 'react-utils';
import OxDataGrid from '../../elements/OxDataGrid/OxDataGrid';
import {
  loadSbomLibraries,
  selectSbom,
} from '../actions/sbom-libraries-actions';
import { useSbomHeader } from '../hooks/use-sbom-header';
import { SbomLibraryItem } from '../sbom-types';
import config from '../config/sbom-config.json';

const SbomTable: FC<SbomTableProps> = ({
  libraries,
  loading,
  selectedSbomId,
}) => {
  const { classes } = useStyles();
  const columns = useSbomHeader(classes);
  const { onScroll } = useInfinityScroll({
    load: loadSbomLibraries,
    threshold: 0.9,
  });
  const onRowClick = useCallback((row: SbomLibraryItem) => {
    if (row.dependencyGraphNodes?.length) {
      selectSbom(row);
    }
  }, []);
  return (
    <div className={classes.tableContainer}>
      <OxDataGrid
        activeRowKey='id'
        activeRowValue={selectedSbomId}
        rowHeight={config.table.rowHeight}
        onScroll={onScroll}
        columns={columns}
        rows={libraries}
        loading={loading}
        onRowClick={onRowClick}
      />
    </div>
  );
};

const useStyles = makeStyles()({
  tableContainer: {
    borderRadius: 10,
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  textCenter: {
    textAlign: important('center'),
  },
  flexCenter: {
    justifyContent: 'center',
  },
  headerCell: {
    textAlign: 'center',
    '& .rdg-header-sort-name': {
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
      lineHeight: 1,
      alignSelf: 'center',
      fontSize: 10,
    },
  },
  noPadding: {
    paddingInline: important('0'),
  },
  textOverFlow: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    display: '-webkit-box',
    whiteSpace: 'pre-wrap',
    lineClamp: 2,
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  },
  columnsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
});

export interface SbomTableProps {
  libraries: SbomLibraryItem[];
  loading: boolean;
  selectedSbomId?: string;
}

export default SbomTable;
